import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ROLES } from "@/lib/constants";

export const RoleSelect = ({ value, onChange, testId = "role-select", roles = ROLES }) => (
  <div className="space-y-2">
    <Label>Role</Label>
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}>
        <SelectValue placeholder="Choose a role" />
      </SelectTrigger>
      <SelectContent>
        {roles.map((r) => (
          <SelectItem key={r.value} value={r.value} data-testid={`${testId}-option-${r.value}`}>
            {r.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export function OrgFields({ role, regionId, communityId, onChange, regions, communities, testPrefix = "org" }) {
  if (role === "regional_manager") {
    return (
      <div className="space-y-2">
        <Label>Region</Label>
        <Select value={regionId || undefined} onValueChange={(v) => onChange({ region_id: v, community_id: null })}>
          <SelectTrigger data-testid={`${testPrefix}-region-select`}>
            <SelectValue placeholder="Choose a region" />
          </SelectTrigger>
          <SelectContent>
            {regions.map((r) => (
              <SelectItem key={r.id} value={r.id} data-testid={`${testPrefix}-region-option-${r.code}`}>
                {r.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }
  if (role === "community_manager" || role === "maintenance_tech") {
    return (
      <div className="space-y-2">
        <Label>Community</Label>
        <Select value={communityId || undefined} onValueChange={(v) => onChange({ community_id: v, region_id: null })}>
          <SelectTrigger data-testid={`${testPrefix}-community-select`}>
            <SelectValue placeholder="Choose a community" />
          </SelectTrigger>
          <SelectContent>
            {communities.map((c) => (
              <SelectItem key={c.id} value={c.id} data-testid={`${testPrefix}-community-option-${c.id}`}>
                {c.name} · {c.city}, {c.state}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }
  if (role === "admin") {
    return <p className="text-xs text-muted-foreground">Admins have company-wide access and no community assignment.</p>;
  }
  return null;
}
